import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { GLOBAL_APPLICATION_EXTERNAL_LINKS } from "../../../../../../../../links"
import { StyledProudItemsContainer } from "./styled"

const ProudSection = () => {
  return (
    <StyledProudItemsContainer>
      <Link
        target="_blank"
        to={GLOBAL_APPLICATION_EXTERNAL_LINKS.CLUTCH_IMPRESSIT}
        rel="nofollow noreferrer"
      >
        <StaticImage
          src="../../../../../../../../images/black-clutch-logo.svg"
          alt="clutch"
        />
      </Link>

      <Link
        target="_blank"
        to={GLOBAL_APPLICATION_EXTERNAL_LINKS.GOODFIRMS_IMPRESSIT}
        rel="nofollow noreferrer"
      >
        <StaticImage
          src="../../../../../../../../images/black-good-firms.svg"
          alt="good-firms"
        />
      </Link>
      <Link
        target="_blank"
        to={GLOBAL_APPLICATION_EXTERNAL_LINKS.WADLINE_IMPRESSIT}
        rel="nofollow noreferrer"
      >
        <StaticImage
          src="../../../../../../../../images/black-wadline.svg"
          alt="wadline"
        />
      </Link>
      <Link
        target="_blank"
        to={GLOBAL_APPLICATION_EXTERNAL_LINKS.UPCITY_IMPRESSIT}
        rel="nofollow noreferrer"
      >
        <StaticImage
          src="../../../../../../../../images/black-upcity-logo.svg"
          alt="upcity"
        />
      </Link>
    </StyledProudItemsContainer>
  )
}

export default ProudSection;
